<script lang="ts">
    import TrustpilotLogo from 'general/icons/TrustpilotLogo.svelte';
    import TrustpilotStars from 'general/components/trustpilotStars/TrustpilotStars.svelte';
    import {trustpilotStore} from 'general/store/trustpilot';
    import {parseBigNumber} from 'general/libs/parseBigNumber/parseBigNumber';

    import s from './style.module.css';
</script>

<div class={s.desktopTrustpilot}>
    <TrustpilotLogo width={90} height={22} />
    <TrustpilotStars />
    <span class={s.trustpilotReviewsNumber} role="presentation">
        {parseBigNumber($trustpilotStore.numberOfReviews)} Reviews
    </span>
</div>
